"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupHeading = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var react_select_1 = require("react-select");
var noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
var some_1 = tslib_1.__importDefault(require("lodash/fp/some"));
var uniqBy_1 = tslib_1.__importDefault(require("lodash/fp/uniqBy"));
var differenceBy_1 = tslib_1.__importDefault(require("lodash/fp/differenceBy"));
var clsx_1 = tslib_1.__importDefault(require("clsx"));
var Checkbox_1 = require("../../Checkbox");
var headerCheckboxClickRollupHandler_1 = tslib_1.__importDefault(require("../utils/headerCheckboxClickRollupHandler"));
var theme_1 = require("../../../theme");
var headerCheckboxClickHandler = function (_a) {
    var isSelected = _a.isSelected, _b = _a.onChange, onChange = _b === void 0 ? noop_1.default : _b, value = _a.value, associatedValues = _a.associatedValues;
    if (isSelected) {
        onChange(differenceBy_1.default('value', value, associatedValues), {
            action: 'deselect-option',
        });
    }
    else {
        onChange(uniqBy_1.default('value', tslib_1.__spreadArrays(value, associatedValues)), {
            action: 'select-option',
        });
    }
};
exports.GroupHeading = function (props) {
    var id = props.id, children = props.children, data = props.data, _a = props.isSelected, indeterminate = _a.indeterminate, allSelected = _a.allSelected, isExpanded = props.isExpanded, setIsExpanded = props.setIsExpanded, _b = props.selectProps, expandableGroups = _b.expandableGroups, isGrouped = _b.isGrouped, selectGroupedCheckbox = _b.selectGroupedCheckbox, _c = _b.onChange, onChange = _c === void 0 ? noop_1.default : _c, value = _b.value, enableGroupSelection = _b.enableGroupSelection;
    var val = value !== null && value !== void 0 ? value : [];
    var isGroupSelected = enableGroupSelection
        ? some_1.default(function (_a) {
            var v = _a.value;
            return !!v && v === data.value;
        }, val)
        : false;
    var handleHeaderCheckboxClick = function () {
        var associatedValues = enableGroupSelection ? [data] : data.options;
        var params = {
            isSelected: enableGroupSelection ? isGroupSelected : allSelected,
            onChange: onChange,
            value: val,
            associatedValues: associatedValues,
        };
        if (enableGroupSelection) {
            headerCheckboxClickRollupHandler_1.default(params);
        }
        else {
            headerCheckboxClickHandler(params);
        }
    };
    var handleHeaderClick = function () {
        setIsExpanded(function (expanded) { return !expanded; });
    };
    var checkboxId = id + "-checkbox";
    return (children !== '' && (react_1.default.createElement(react_1.default.Fragment, null, expandableGroups && isGrouped ? (react_1.default.createElement(StyledGroupHeadingWrapper, { className: clsx_1.default('group-heading-wrapper', {
            'is-selected': enableGroupSelection
                ? isGroupSelected
                : allSelected || indeterminate,
        }) },
        react_1.default.createElement(react_select_1.components.GroupHeading, tslib_1.__assign({ className: "expandable" }, props),
            react_1.default.createElement(StyledIcon, { onClick: handleHeaderClick },
                react_1.default.createElement("i", { className: isExpanded ? 'icon--chevron_down' : 'icon--chevron_right' })),
            selectGroupedCheckbox && (react_1.default.createElement(CheckboxContainer, null,
                react_1.default.createElement(Checkbox_1.Checkbox, { id: checkboxId, onChange: handleHeaderCheckboxClick, checked: enableGroupSelection ? isGroupSelected : allSelected, indeterminate: enableGroupSelection
                        ? false
                        : indeterminate && !allSelected }))),
            react_1.default.createElement(StyledIcon, { onClick: handleHeaderClick },
                react_1.default.createElement("i", { className: isExpanded ? 'icon--folder_open' : 'icon--folder' })),
            react_1.default.createElement(StyledGroupHeadingLabel, { htmlFor: checkboxId }, children)))) : (react_1.default.createElement(react_select_1.components.GroupHeading, tslib_1.__assign({}, props),
        react_1.default.createElement(StyledGroupHeadingText, null, children))))));
};
var StyledIcon = styled_components_1.default.span(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-right: 0.8rem;\n"], ["\n  margin-right: 0.8rem;\n"])));
var CheckboxContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: inline-flex;\n  vertical-align: middle;\n  padding-right: 0.8rem;\n"], ["\n  display: inline-flex;\n  vertical-align: middle;\n  padding-right: 0.8rem;\n"])));
var StyledGroupHeadingWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  margin-left: 0rem;\n\n  &.is-selected {\n    background-color: ", ";\n  }\n"], ["\n  margin-left: 0rem;\n\n  &.is-selected {\n    background-color: ", ";\n  }\n"])), theme_1.hexWithTransparency(theme_1.theme.colors.aqua[200], 0.4));
var StyledGroupHeadingLabel = styled_components_1.default.label(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  line-height: 1.6rem !important;\n  font-size: 1.3rem !important;\n  cursor: pointer;\n"], ["\n  line-height: 1.6rem !important;\n  font-size: 1.3rem !important;\n  cursor: pointer;\n"])));
var StyledGroupHeadingText = styled_components_1.default.span(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  line-height: 1.6rem !important;\n  font-size: 1.3rem !important;\n  cursor: pointer;\n"], ["\n  line-height: 1.6rem !important;\n  font-size: 1.3rem !important;\n  cursor: pointer;\n"])));
exports.GroupHeading.displayName = 'FOS_ReactSelect_GroupHeading';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
